import styles from "./About.module.css";
import vaibhavPhoto from "../../assets/vaibhav.jpg";
import aboutData from "../../data/about-data";

const About = ({ active }) => {
  const scrollActiveIntoViewHandler = (e) => {
    const activeEle = document.getElementById(e.target.dataset.hash);
    activeEle.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <section className={styles["about"]}>
      <h1 className={styles["about-heading"]}>{aboutData.heading}</h1>
      <img
        src={vaibhavPhoto}
        alt="Vaibhav Sharma"
        className={styles["about-profile-image"]}
      />
      <p className={styles["about-bio"]}>{aboutData.bio}</p>
      <div className={styles["about-info-links"]}>
        <p
          className={`${styles["info-link"]} ${
            active === "experience" ? styles["active"] : ""
          }`}
          data-hash="experience"
          onClick={scrollActiveIntoViewHandler}
        >
          <span className={styles["link-bar"]}></span>
          Experience
        </p>
        <p
          className={`${styles["info-link"]} ${
            active === "education" ? styles["active"] : ""
          }`}
          data-hash="education"
          onClick={scrollActiveIntoViewHandler}
        >
          <span className={styles["link-bar"]}></span>
          Education
        </p>
        <p
          className={`${styles["info-link"]} ${
            active === "projects" ? styles["active"] : ""
          }`}
          data-hash="projects"
          onClick={scrollActiveIntoViewHandler}
        >
          <span className={styles["link-bar"]}></span>
          Projects
        </p>
        <p
          className={`${styles["info-link"]} ${
            active === "skills" ? styles["active"] : ""
          }`}
          data-hash="skills"
          onClick={scrollActiveIntoViewHandler}
        >
          <span className={styles["link-bar"]}></span>
          Skills
        </p>
        <p
          className={`${styles["info-link"]} ${
            active === "resume" ? styles["active"] : ""
          }`}
          data-hash="resume"
          onClick={scrollActiveIntoViewHandler}
        >
          <span className={styles["link-bar"]}></span>
          Resume
        </p>
      </div>
      <div className={styles["about-media-links"]}>
        <a
          href={aboutData.github}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            className={styles["about-media-link-icon"]}
            width="18"
            height="18"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.0432 1.17993C11.8147 1.17993 1.08765 12.0878 1.08765 25.5445C1.08765 36.3096 7.95165 45.4426 17.4699 48.6643C18.6671 48.8899 19.1067 48.1358 19.1067 47.4922C19.1067 46.9112 19.0845 44.9919 19.0742 42.956C12.4097 44.4299 11.0034 40.0812 11.0034 40.0812C9.9137 37.265 8.34358 36.5161 8.34358 36.5161C6.17009 35.0039 8.50742 35.035 8.50742 35.035C10.913 35.2065 12.1796 37.5458 12.1796 37.5458C14.3162 41.2707 17.7837 40.1938 19.1507 39.5712C19.3657 37.9969 19.9866 36.9212 20.6716 36.3132C15.3508 35.6971 9.7574 33.6079 9.7574 24.2719C9.7574 21.6118 10.6932 19.4383 12.2256 17.732C11.9769 17.1179 11.1569 14.6402 12.4577 11.2841C12.4577 11.2841 14.4693 10.6293 19.0472 13.7816C20.9581 13.2418 23.0074 12.971 25.0432 12.9618C27.0791 12.971 29.13 13.2418 31.0444 13.7816C35.6167 10.6293 37.6256 11.2841 37.6256 11.2841C38.9295 14.6402 38.1091 17.1179 37.8604 17.732C39.3964 19.4383 40.3259 21.6118 40.3259 24.2719C40.3259 33.6301 34.7218 35.6906 29.3874 36.2938C30.2467 37.0499 31.0123 38.5327 31.0123 40.8059C31.0123 44.0655 30.9845 46.6893 30.9845 47.4922C30.9845 48.1406 31.4157 48.9003 32.63 48.6611C42.1431 45.4357 48.9984 36.3059 48.9984 25.5445C48.9984 12.0878 38.273 1.17993 25.0432 1.17993"
              fill="#3F4852"
            />
            <path
              d="M25.0432 1.17993C11.8147 1.17993 1.08765 12.0878 1.08765 25.5445C1.08765 36.3096 7.95165 45.4426 17.4699 48.6643C18.6671 48.8899 19.1067 48.1358 19.1067 47.4922C19.1067 46.9112 19.0845 44.9919 19.0742 42.956C12.4097 44.4299 11.0034 40.0812 11.0034 40.0812C9.9137 37.265 8.34358 36.5161 8.34358 36.5161C6.17009 35.0039 8.50742 35.035 8.50742 35.035C10.913 35.2065 12.1796 37.5458 12.1796 37.5458C14.3162 41.2707 17.7837 40.1938 19.1507 39.5712C19.3657 37.9969 19.9866 36.9212 20.6716 36.3132C15.3508 35.6971 9.7574 33.6079 9.7574 24.2719C9.7574 21.6118 10.6932 19.4383 12.2256 17.732C11.9769 17.1179 11.1569 14.6402 12.4577 11.2841C12.4577 11.2841 14.4693 10.6293 19.0472 13.7816C20.9581 13.2418 23.0074 12.971 25.0432 12.9618C27.0791 12.971 29.13 13.2418 31.0444 13.7816C35.6167 10.6293 37.6256 11.2841 37.6256 11.2841C38.9295 14.6402 38.1091 17.1179 37.8604 17.732C39.3964 19.4383 40.3259 21.6118 40.3259 24.2719C40.3259 33.6301 34.7218 35.6906 29.3874 36.2938C30.2467 37.0499 31.0123 38.5327 31.0123 40.8059C31.0123 44.0655 30.9845 46.6893 30.9845 47.4922C30.9845 48.1406 31.4157 48.9003 32.63 48.6611C42.1431 45.4357 48.9984 36.3059 48.9984 25.5445C48.9984 12.0878 38.273 1.17993 25.0432 1.17993"
              stroke="#3F4852"
            />
            <path
              d="M10.1608 36.1623C10.1081 36.2838 9.92085 36.3197 9.75027 36.2366C9.57652 36.1571 9.47893 35.9921 9.53526 35.8706C9.58683 35.746 9.77447 35.7117 9.94782 35.7944C10.122 35.8743 10.2211 36.0409 10.1608 36.1623"
              fill="#3F4852"
            />
            <path
              d="M10.1608 36.1623C10.1081 36.2838 9.92085 36.3197 9.75027 36.2366C9.57652 36.1571 9.47893 35.9921 9.53526 35.8706C9.58683 35.746 9.77447 35.7117 9.94782 35.7944C10.122 35.8743 10.2211 36.0409 10.1608 36.1623"
              stroke="#3F4852"
            />
            <path
              d="M11.1312 37.263C11.0169 37.3707 10.7936 37.3207 10.642 37.1504C10.4854 36.9806 10.456 36.7534 10.5718 36.6441C10.6896 36.5363 10.9062 36.5868 11.0633 36.7566C11.22 36.9285 11.2506 37.1541 11.1312 37.263"
              fill="#3F4852"
            />
            <path
              d="M11.1312 37.263C11.0169 37.3707 10.7936 37.3207 10.642 37.1504C10.4854 36.9806 10.456 36.7534 10.5718 36.6441C10.6896 36.5363 10.9062 36.5868 11.0633 36.7566C11.22 36.9285 11.2506 37.1541 11.1312 37.263"
              stroke="#3F4852"
            />
            <path
              d="M12.0757 38.6662C11.929 38.7699 11.689 38.6726 11.5406 38.456C11.3938 38.2393 11.3938 37.9795 11.5438 37.8754C11.6925 37.7713 11.929 37.8649 12.0793 38.0799C12.2257 38.2998 12.2257 38.5601 12.0757 38.6662"
              fill="#3F4852"
            />
            <path
              d="M12.0757 38.6662C11.929 38.7699 11.689 38.6726 11.5406 38.456C11.3938 38.2393 11.3938 37.9795 11.5438 37.8754C11.6925 37.7713 11.929 37.8649 12.0793 38.0799C12.2257 38.2998 12.2257 38.5601 12.0757 38.6662"
              stroke="#3F4852"
            />
            <path
              d="M13.3696 40.0219C13.2383 40.1692 12.9587 40.1297 12.754 39.9287C12.5445 39.7322 12.4862 39.4534 12.6179 39.3062C12.7508 39.1585 13.0321 39.2001 13.2383 39.3994C13.4462 39.5955 13.5097 39.8763 13.3696 40.0219"
              fill="#3F4852"
            />
            <path
              d="M13.3696 40.0219C13.2383 40.1692 12.9587 40.1297 12.754 39.9287C12.5445 39.7322 12.4862 39.4534 12.6179 39.3062C12.7508 39.1585 13.0321 39.2001 13.2383 39.3994C13.4462 39.5955 13.5097 39.8763 13.3696 40.0219"
              stroke="#3F4852"
            />
            <path
              d="M15.1548 40.809C15.0969 40.9999 14.8275 41.0866 14.5562 41.0055C14.2852 40.922 14.1079 40.6985 14.1626 40.5056C14.219 40.3136 14.4895 40.2232 14.7628 40.3099C15.0334 40.393 15.2111 40.6149 15.1548 40.809"
              fill="#3F4852"
            />
            <path
              d="M15.1548 40.809C15.0969 40.9999 14.8275 41.0866 14.5562 41.0055C14.2852 40.922 14.1079 40.6985 14.1626 40.5056C14.219 40.3136 14.4895 40.2232 14.7628 40.3099C15.0334 40.393 15.2111 40.6149 15.1548 40.809"
              stroke="#3F4852"
            />
            <path
              d="M17.1152 40.9552C17.122 41.1561 16.8919 41.3228 16.6071 41.326C16.3207 41.3329 16.089 41.1703 16.0858 40.9726C16.0858 40.7696 16.3107 40.6046 16.5972 40.5998C16.882 40.5941 17.1152 40.7555 17.1152 40.9552"
              fill="#3F4852"
            />
            <path
              d="M17.1152 40.9552C17.122 41.1561 16.8919 41.3228 16.6071 41.326C16.3207 41.3329 16.089 41.1703 16.0858 40.9726C16.0858 40.7696 16.3107 40.6046 16.5972 40.5998C16.882 40.5941 17.1152 40.7555 17.1152 40.9552"
              stroke="#3F4852"
            />
            <path
              d="M18.9397 40.6392C18.9738 40.8353 18.7759 41.0366 18.493 41.0899C18.2149 41.1419 17.9575 41.0209 17.9222 40.8264C17.8877 40.6255 18.0892 40.4241 18.3669 40.3721C18.6501 40.3221 18.9036 40.4399 18.9397 40.6392"
              fill="#3F4852"
            />
            <path
              d="M18.9397 40.6392C18.9738 40.8353 18.7759 41.0366 18.493 41.0899C18.2149 41.1419 17.9575 41.0209 17.9222 40.8264C17.8877 40.6255 18.0892 40.4241 18.3669 40.3721C18.6501 40.3221 18.9036 40.4399 18.9397 40.6392"
              stroke="#3F4852"
            />
          </svg>
          <span className={styles["about-media-link-text"]}>Github</span>
        </a>
        <a
          href={aboutData.linkedin}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM11.5216 19.8778H16.9605V36.2196H11.5216V19.8778ZM17.3188 14.8227C17.2835 13.2204 16.1377 12 14.277 12C12.4164 12 11.2 13.2204 11.2 14.8227C11.2 16.3918 12.3805 17.6473 14.2064 17.6473H14.2412C16.1377 17.6473 17.3188 16.3918 17.3188 14.8227ZM30.3131 19.4941C33.8922 19.4941 36.5754 21.8303 36.5754 26.8497L36.5752 36.2196H31.1365V27.4767C31.1365 25.2807 30.3494 23.7822 28.3805 23.7822C26.8779 23.7822 25.9829 24.7924 25.5898 25.7682C25.446 26.1178 25.4107 26.605 25.4107 27.0934V36.22H19.9711C19.9711 36.22 20.0428 21.4117 19.9711 19.8783H25.4107V22.1929C26.1325 21.0802 27.4254 19.4941 30.3131 19.4941Z"
              fill="#3F4852"
            />
          </svg>

          <span className={styles["about-media-link-text"]}>LinkedIn</span>
        </a>
        <a
          href={aboutData.codepen}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM36.7194 20.2181C36.7295 20.2437 36.738 20.2692 36.7636 20.3475C36.7711 20.3755 36.7765 20.4049 36.7897 20.4774L36.7907 20.4832C36.7969 20.5281 36.8 20.5746 36.8 20.6219V28.1781C36.8 28.2246 36.7969 28.2711 36.7822 28.3633C36.7767 28.3936 36.7713 28.423 36.7465 28.5044C36.738 28.53 36.7295 28.5563 36.6954 28.6338C36.6845 28.6579 36.6729 28.6811 36.6287 28.754C36.6148 28.7764 36.6 28.7973 36.5473 28.8648C36.5303 28.8841 36.5125 28.9043 36.452 28.964C36.4319 28.9818 36.4117 28.9988 36.3916 29.0151C36.3877 29.018 36.3839 29.021 36.3799 29.0241C36.367 29.0341 36.3518 29.0458 36.3257 29.0647L24.9913 36.621C24.8123 36.7403 24.6061 36.8 24.4 36.8C24.1938 36.8 23.9877 36.7403 23.8087 36.621L12.4751 29.0647C12.4724 29.0631 12.4699 29.0611 12.4637 29.0563C12.4553 29.0498 12.4403 29.0382 12.4092 29.0151C12.3883 28.9988 12.3681 28.9818 12.3061 28.9221C12.2875 28.9043 12.2697 28.8841 12.2162 28.8183C12.2007 28.7973 12.186 28.7764 12.1411 28.7051C12.1279 28.6811 12.1163 28.6578 12.0814 28.5827C12.0705 28.5563 12.062 28.53 12.0372 28.4525C12.0295 28.423 12.024 28.3936 12.0101 28.3176C12.0039 28.2711 12 28.2246 12 28.1781V20.6219C12 20.5746 12.0039 20.5281 12.0186 20.4366C12.024 20.4064 12.0295 20.3762 12.0535 20.2956C12.062 20.2693 12.0705 20.2437 12.1046 20.1662C12.1163 20.1414 12.1279 20.1181 12.1721 20.0461C12.186 20.0236 12.2007 20.0019 12.2534 19.9352C12.2697 19.9151 12.2875 19.8957 12.3488 19.836C12.3681 19.8182 12.3883 19.8011 12.4092 19.7849C12.4247 19.7725 12.4402 19.7601 12.4751 19.7353L23.8087 12.179C24.1675 11.9403 24.6333 11.9403 24.9913 12.179L36.3257 19.7353C36.3284 19.7369 36.3309 19.7389 36.3371 19.7437C36.3455 19.7502 36.3605 19.7618 36.3916 19.7849C36.4117 19.8011 36.4319 19.8182 36.4939 19.8771C36.5125 19.8957 36.5303 19.9151 36.5838 19.9809C36.6 20.0019 36.6148 20.0236 36.659 20.0956C36.6729 20.1181 36.6845 20.1414 36.7194 20.2181Z"
              fill="#3F4852"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.4656 15.0574L33.8155 20.6234L30.0862 23.1181L25.4656 20.0274V15.0574ZM24.4 26.9211L20.6312 24.4L24.4 21.8789L28.1696 24.4L24.4 26.9211ZM25.4656 28.7725V33.7426L33.8155 28.1766L30.0862 25.6826L25.4656 28.7725ZM34.6687 26.1833L32.0027 24.4L34.6687 22.6167V26.1833ZM14.9845 28.1766L23.3344 33.7426V28.7725L18.7146 25.6826L14.9845 28.1766ZM14.1312 22.6167L16.798 24.4L14.1312 26.1833V22.6167ZM23.3344 20.0274V15.0574L14.9845 20.6234L18.7146 23.1181L23.3344 20.0274Z"
              fill="#3F4852"
            />
          </svg>
          <span className={styles["about-media-link-text"]}>Codepen</span>
        </a>
        <a
          href={aboutData.mail}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48ZM24.3344 22.653C26.2995 22.653 35.8544 17.28 35.8544 17.28L35.8698 16.32C35.8698 15.2602 35.0096 14.4 33.9469 14.4H14.7219C13.6602 14.4 12.8 15.2602 12.8 16.32V17.1754C12.8 17.1754 22.4595 22.653 24.3344 22.653ZM12.8154 20.16C12.8144 20.16 22.4595 25.293 24.3344 25.293C26.3898 25.293 35.8544 20.16 35.8544 20.16L35.8698 31.68C35.8698 32.7398 35.0096 33.6 33.9469 33.6H14.7219C13.6611 33.6 12.8 32.7398 12.8 31.68L12.8154 20.16Z"
              fill="#3F4852"
            />
          </svg>
          <span className={styles["about-media-link-text"]}>Mail</span>
        </a>
        <a
          href={aboutData.twitter}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM23.3316 20.338L23.2812 19.5075C23.1301 17.3551 24.4563 15.3891 26.5548 14.6265C27.327 14.3553 28.6364 14.3214 29.4926 14.5587C29.8283 14.6604 30.4663 14.9993 30.9195 15.3044L31.7421 15.8637L32.6486 15.5756C33.1523 15.423 33.8238 15.1688 34.1259 14.9993C34.4113 14.8468 34.6631 14.762 34.6631 14.8129C34.6631 15.101 34.042 16.084 33.5216 16.6263C32.8165 17.389 33.018 17.4568 34.4449 16.9483C35.3011 16.6602 35.3178 16.6602 35.15 16.9822C35.0492 17.1517 34.5288 17.7449 33.9748 18.2872C33.0347 19.2194 32.9844 19.3211 32.9844 20.1007C32.9844 21.304 32.4136 23.8123 31.8428 25.1851C30.7852 27.7612 28.5189 30.422 26.2526 31.7609C23.063 33.6422 18.8157 34.1167 15.24 33.0151C14.0481 32.6422 12 31.6931 12 31.5237C12 31.4728 12.6211 31.405 13.3766 31.3881C14.9546 31.3542 16.5326 30.9135 17.8756 30.1339L18.7822 29.5916L17.7413 29.2357C16.264 28.7272 14.9378 27.5578 14.6021 26.4562C14.5013 26.1003 14.5349 26.0833 15.475 26.0833L16.4487 26.0664L15.6261 25.6766C14.6524 25.1851 13.7627 24.3546 13.3262 23.5072C13.0072 22.8971 12.6044 21.3548 12.7219 21.2362C12.7554 21.1854 13.108 21.287 13.5109 21.4226C14.6692 21.8463 14.8203 21.7446 14.1488 21.0328C12.8897 19.7448 12.5036 17.8296 13.108 16.0162L13.3934 15.2027L14.5013 16.3043C16.7677 18.5245 19.4369 19.8465 22.4922 20.2363L23.3316 20.338Z"
              fill="#3F4852"
            />
          </svg>
          <span className={styles["about-media-link-text"]}>Twitter</span>
        </a>
        <a
          href={aboutData.behance}
          target="_blank"
          rel="noreferrer"
          className={styles["about-media-link"]}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM34.3376 18.6699H27.5583V16.7276H34.3376V18.6699ZM33.74 20.3003C32.9242 19.9395 32.0076 19.7583 30.9886 19.7583C29.2742 19.7583 27.8819 20.2944 26.8057 21.3591C25.7325 22.4267 25.1951 23.9606 25.1951 25.9608C25.1951 28.0932 25.7882 29.6345 26.9818 30.5804C28.1694 31.5278 29.5436 32 31.1015 32C32.9875 32 34.455 31.4387 35.5026 30.3176C36.1739 29.6108 36.5532 28.9143 36.636 28.2313H33.5128C33.3321 28.5698 33.1214 28.8342 32.8821 29.0257C32.4471 29.3776 31.8796 29.5543 31.1858 29.5543C30.5265 29.5543 29.9651 29.4088 29.4985 29.1193C28.7278 28.6545 28.3244 27.8422 28.2732 26.6855H36.7971C36.8106 25.6891 36.7775 24.9229 36.6947 24.3942C36.5532 23.4899 36.2432 22.694 35.76 22.008C35.2302 21.2299 34.5574 20.6597 33.74 20.3003ZM18.8448 16C20.7744 16.0282 22.1396 16.5821 22.9449 17.6631C23.4281 18.3269 23.6704 19.1198 23.6704 20.0449C23.6704 20.9968 23.4281 21.7645 22.9389 22.3436C22.6649 22.6673 22.2631 22.9643 21.7317 23.2316C22.5385 23.5226 23.1466 23.9814 23.5605 24.6096C23.9699 25.2362 24.1761 25.9994 24.1761 26.8963C24.1761 27.8214 23.9413 28.6515 23.4702 29.3851C23.1722 29.8706 22.7989 30.2805 22.3504 30.6131C21.8461 30.9947 21.2516 31.2546 20.5637 31.3971C19.8758 31.5382 19.1323 31.6065 18.3285 31.6065H11.2V16H18.8448Z"
              fill="#3F4852"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.3533 18.71H17.7972C18.5543 18.71 19.1774 18.7916 19.6681 18.9535C20.2341 19.1881 20.517 19.6677 20.517 20.3968C20.517 21.0502 20.3018 21.5075 19.8743 21.7659C19.4438 22.0243 18.8854 22.1535 18.2006 22.1535H14.3533V18.71ZM29.1643 22.9078C29.5963 22.4683 30.2074 22.2485 30.9901 22.2485C31.7126 22.2485 32.3161 22.4549 32.8068 22.8692C33.2915 23.2865 33.5654 23.8923 33.6211 24.6942H28.3485C28.4599 23.9428 28.7323 23.3474 29.1643 22.9078ZM18.2487 24.7358H14.3533V28.898H18.1945C18.8809 28.898 19.4168 28.8059 19.7976 28.6233C20.4914 28.2817 20.8376 27.6343 20.8376 26.6751C20.8376 25.8613 20.5035 25.3045 19.8307 25.0001C19.4544 24.8308 18.9261 24.7417 18.2487 24.7358Z"
              fill="#3F4852"
            />
          </svg>
          <span className={styles["about-media-link-text"]}>Behance</span>
        </a>
      </div>
    </section>
  );
};

export default About;
